import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { BarChart3Icon } from "lucide-react";

type MonthOption = { value: string; label: string };

type DashboardOverviewSectionProps = {
  yearOptions: number[];
  yearSelectValue: string;
  monthValue: string | undefined;
  monthOptions: readonly MonthOption[];
  monthDisabled: boolean;
  dateFrom: string;
  dateTo: string;
  onYearSelect: (value: string) => void;
  onMonthSelect: (value: string) => void;
};

export function DashboardOverviewSection({
  yearOptions,
  yearSelectValue,
  monthValue,
  monthOptions,
  monthDisabled,
  dateFrom,
  dateTo,
  onYearSelect,
  onMonthSelect,
}: DashboardOverviewSectionProps) {
  const nav = useNavigate();

  return (
    <section>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <h1 className="font-semibold text-2xl tracking-tight">ແຜງຄວບຄຸມ</h1>
        <div className="flex flex-wrap items-end gap-2">
          <div className="flex flex-col gap-1">
            <Label htmlFor="dash-filter-year" className="text-xs">
              ປີ
            </Label>
            <Select value={yearSelectValue} onValueChange={onYearSelect}>
              <SelectTrigger
                id="dash-filter-year"
                className="h-9 w-[120px] bg-background"
              >
                <SelectValue placeholder="ປີ" />
              </SelectTrigger>
              <SelectContent>
                {yearOptions.map((y) => (
                  <SelectItem key={y} value={String(y)}>
                    {y}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="dash-filter-month" className="text-xs">
              ເດືອນ
            </Label>
            <Select
              value={monthValue}
              onValueChange={onMonthSelect}
              disabled={monthDisabled}
            >
              <SelectTrigger
                id="dash-filter-month"
                className="h-9 w-[min(100%,200px)] bg-background sm:w-[200px]"
              >
                <SelectValue placeholder="ເລືອກເດືອນ" />
              </SelectTrigger>
              <SelectContent>
                {monthOptions.map((mo) => (
                  <SelectItem key={mo.value} value={mo.value}>
                    {mo.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-9 bg-background"
            onClick={() =>
              void nav({
                to: "/app/reports/revenue",
                search: { dateFrom, dateTo },
              })
            }
          >
            <BarChart3Icon className="mr-2 size-4" />
            ລາຍງານລາຍຮັບ
          </Button>
        </div>
      </div>
    </section>
  );
}
